import { inject, Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AuthenticationService } from "../services/authentication.service";
import { FeatureFlags } from '@app/core/feature-flags/feature-flag.types';
import { Route } from '../enums/route.enum';
import { FeatureFlagStore } from '../feature-flags/feature-flag.store';

@Injectable({ providedIn: 'root' })
export class AuthenticationSandbox {
  private readonly navCtrl = inject(NavController);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly featureFlagStore = inject(FeatureFlagStore);

  publicJobSearchFeatureFlag = this.featureFlagStore.getFeatureFlag(FeatureFlags.PublicJobSearch);
  registerWizardFeatureFlag = this.featureFlagStore.getFeatureFlag(FeatureFlags.RegisterWizard);

  login(): void {
    this.authenticationService.login();
  }

  register(): void {
    this.authenticationService.register();
  }

  logout(): void {
    this.authenticationService.logout();
  }

  unauthenticatedSignIn(): void {
    this.navCtrl.navigateRoot([Route.Login]);
  }
}
